import { Directive, HostListener, inject } from '@angular/core';
import { LoadingService } from '../services/loading.service';
import { TranslateService } from '@ngx-translate/core';

@Directive({
  selector: '[appLinkLoading]',
  standalone: true
})
export class LinkLoadingDirective {
  private readonly loadingService = inject(LoadingService);
  private readonly translate = inject(TranslateService);

  @HostListener('click', ['$event'])
  onClick(event: Event): void {
    console.log('🖱️ LinkLoadingDirective: Clique detectado em link');
    
    // Verifica se é um link válido (routerLink ou href)
    const target = event.target as HTMLElement;
    const link = target.closest('a[routerLink], a[href]');
    
    if (link) {
      // Para routerLink, pega o valor do atributo
      const routerLink = link.getAttribute('routerLink');
      const href = link.getAttribute('href');
      
      // Para routerLink, pode ser um array, então precisa processar
      let url = '';
      if (routerLink) {
        try {
          // Se for um array JSON, parseia
          if (routerLink.startsWith('[') && routerLink.endsWith(']')) {
            const urlArray = JSON.parse(routerLink);
            url = urlArray[0] || '';
          } else {
            url = routerLink;
          }
        } catch {
          url = routerLink;
        }
      } else if (href) {
        url = href;
      }
      
      console.log('🔗 LinkLoadingDirective: Navegando para:', url);
      
      // Determina a mensagem baseada na rota
      const message = this.getLoadingMessage(url || '');
      console.log('🔄 LinkLoadingDirective: Mostrando loading imediatamente:', message);
      
      // Mostra o loading imediatamente no clique
      this.loadingService.show(message);
    }
  }

  private getLoadingMessage(url: string): string {
    // Mapeia URLs para chaves de tradução
    const routeKeys: { [key: string]: string } = {
      '/dmdi/actions': 'loading.actions',
      '/dmdi/project': 'loading.projects',
      '/dmdi/connection': 'loading.connections',
      '/dmdi/workspace': 'loading.workspace',
      '/dashboard': 'loading.dashboard',
      '/home': 'loading.home',
      '/relatorio': 'loading.reports',
      '/webapi': 'loading.webapi',
      '/favorite': 'loading.favorites',
      '/grid': 'loading.grid',
      '/alterar-usuario': 'loading.profile'
    };

    // Procura por correspondência exata primeiro
    if (routeKeys[url]) {
      return this.translate.instant(routeKeys[url]);
    }

    // Procura por correspondência parcial
    for (const route in routeKeys) {
      if (url.startsWith(route)) {
        return this.translate.instant(routeKeys[route]);
      }
    }

    // Mensagem padrão traduzida
    return this.translate.instant('loading.page');
  }
}
